App.filter('healthInsurancePzuwTypeFilter', function () {
    let dictionary = {
        REHABILITATION: 'Rehabilitacja',
        VIP: 'Optimum VIP',
        FULL: 'Optimum',
        EXPANDED: 'Komfort plus',
        BASIC: 'Komfort',
        SENIOR: 'Komfort Senior'
    };

    return function (el) {
        if(!el){
            return el;
        }

        return dictionary[el] || el;
    };
});
